import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import SuspendProjectWidget from '../../../widgets/closeProject/SuspendProjectWidget'
import SuspendHistoryWidget from '../../../widgets/closeProject/SuspendHistoryWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getSuspendForm } from '../../../redux/actions/suspendProject'

export default function SuspendProjectStaff(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [projectId])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getSuspendForm(proposalId)
      if (response.success) setSchemas(response.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnDownloadFile = async (id, fileName) => {
    startLoading()
    try {
      const file = await downlondDocument(projectId, id)
      downloadFile(file, fileName)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />
        {schemas?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
        )}
        {schemas?.forms?.requestNote && (
          <>
            <SuspendProjectWidget
              showCommandButton={!schemas.forms.requestNote.disabled}
              schema={schemas.forms.requestNote}
              attachmentSchema={schemas.forms.attachment}
            />
            <br />
          </>
        )}
        {schemas?.forms?.suspendHistory && (
          <>
            <SuspendHistoryWidget
              data={schemas.forms.suspendHistory.value}
              header={schemas.forms.suspendHistory.header}
            />
            <br />
          </>
        )}
        {schemas?.forms?.cancelSuspendHistory && (
          <>
            <SuspendHistoryWidget
              data={schemas.forms.cancelSuspendHistory.value}
              header={schemas.forms.cancelSuspendHistory.header}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  header: 'ระงับการให้ทุนสนับสนุนโครงการ',
  subHeader: 'ข้อเสนอโครงการ -',
  forms: {
    agreementDetails: {
      title: 'เหตุผลในระงับการให้ทุนสนับสนุนโครงการ',
      content: 'ผู้รับทุนทำผิดข้อบังคับในการดำเนินการ',
      datetime: {
        dateLabel: 'วันที่ : ',
        dateValue: '22 พฤษภาคม 2564',
        timeLabel: 'เวลา : ',
        timeValue: '11:35',
      },
      status: {
        statusLabel: 'สถานะ : ',
        statusValue: 'รอพิจารณาอนุมัติ',
      },
    },
    suspendProject: {
      header: 'ระงับการให้ทุนสนับสนุนโครงการ',
      buttonText: 'เสนอพิจารณาอนุมัติ',
      requestNote: {
        name: 'requestNote',
        hint: 'ระบุเหตุผลในระงับการให้ทุนสนับสนุนโครงการ',
        label: 'เหตุผลในระงับการให้ทุนสนับสนุนโครงการ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'โปรดระบุ เหตุผลในระงับการให้ทุนสนับสนุนโครงการ',
          },
        ],
      },
      attachment: {
        name: 'attachments',
        label: 'เอกสารแนบประกอบการพิจาณา',
        value: null,
      },
    },
    suspendHistory: {
      header: 'ประวัติการระงับการให้ทุนสนับสนุนโครงการ',
      value: [
        {
          times: '1',
          sendDate: '22 พฤษภาคม 2564',
          sendNote: 'ผู้รับทุนทำผิดข้อบังคับในการดำเนินการ',
          sender: 'วัลลภ',
          file: {
            seqNo: 0,
            label: 'เอกสารประกอบการพิจารณา.pdf',
            url: 'http://103.91.191.229:9090/egranting/proposal/project-background/78AEF622-D7D3-443D-BC39-465836CFB184.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cana-access-key%2F20210703%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210703T083012Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=0f2d40ab6dba949131319c7948644482c8c6a455ebe1aac82bc62fc5736a4f69',
            name: 'เอกสารประกอบการพิจารณา.pdf',
            path: 'proposal/project-background/78AEF622-D7D3-443D-BC39-465836CFB184.jpg',
            type: null,
            size: 0,
            id: '403A8DAA-48EB-424D-BC97-ECA7BBE53C47',
          },
          approveDate: '23 พฤษภาคม 2564',
          approveNote: 'เห็นด้วยกับผู้ประสาน',
          approve: true,
          approver: 'ผอ.สุพจ',
        },
      ],
    },
    cancelSuspendHistory: {
      header: 'ประวัติยกเลิกการระงับการให้ทุนสนับสนุนโครงการ',
      value: [
        {
          times: '1',
          sendDate: '22 พฤษภาคม 2564',
          sendNote: 'ผู้รับทุนทำผิดข้อบังคับในการดำเนินการ',
          sender: 'วัลลภ',
          file: {
            seqNo: 0,
            label: 'เอกสารประกอบการพิจารณา.pdf',
            url: 'http://103.91.191.229:9090/egranting/proposal/project-background/78AEF622-D7D3-443D-BC39-465836CFB184.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=cana-access-key%2F20210703%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20210703T083012Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=0f2d40ab6dba949131319c7948644482c8c6a455ebe1aac82bc62fc5736a4f69',
            name: 'เอกสารประกอบการพิจารณา.pdf',
            path: 'proposal/project-background/78AEF622-D7D3-443D-BC39-465836CFB184.jpg',
            type: null,
            size: 0,
            id: '403A8DAA-48EB-424D-BC97-ECA7BBE53C47',
          },
          approveDate: '23 พฤษภาคม 2564',
          approveNote: 'เห็นด้วยกับผู้ประสาน',
          approve: true,
          approver: 'ผอ.สุพจ',
        },
      ],
    },
  },
}
